const TableRow = ({ label, value, isAlternate }) => (
  <tr className={isAlternate ? "bg-lg5" : ""}>
    <td className="expense-table-row-label">{label}</td>
    <td className="expense-table-row-val">{value}</td>
  </tr>
);

export default TableRow;